
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"affected-views.label_one":"1 affected view","affected-views.label_other":"{{count}} affected views"},"de":{"affected-views.label_one":"1 betroffene Sicht","affected-views.label_other":"{{count}} betroffene Sichten"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();